import React, { useState, useEffect, useCallback } from "react";
import { api } from "../../../../../utility/AxiosInceptor";
import { ProgressSpinner } from "primereact/progressspinner";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import UpdateProgram from "./update_acp_programs";

const ShowPrograms = ({ setEditAcp }) => {
  // -------------------- STATE --------------------
  const [showAcps, setShowAcps] = useState(null); // List of ACP programs
  const [showEdit, setShowEdit] = useState(false); // Toggle edit view
  const [selectedProgram, setSelectedProgram] = useState(null); // Currently selected program for edit
  const [arrayOfCodes, setArrayOfCodes] = useState([]); // All program codes
  const [objectForEdit, setObjectForEdit] = useState({}); // Map: programName -> program object

  // Parse logged-in user info
  const loginRes = localStorage.getItem("userData");
  const parseLoginRes = JSON.parse(loginRes);

  // -------------------- HELPERS --------------------

  // Render program active status
  const renderActiveStatus = (rowData) => (
    <p>{rowData.active ? "Active" : "Inactive"}</p>
  );

  // Render banner image with fallback
  const renderBanner = (rowData) => (
    <img
      onError={(e) => {
        e.target.src = "./placeholderimage.jpg";
      }}
      alt="banner"
      style={{
        width: "4.5rem",
        height: "auto",
        marginLeft: "50%",
        transform: "translate(-50%)",
      }}
      src={rowData.banner}
    />
  );

  // -------------------- Handle edit button click --------------------
  const editAcpProgram = useCallback(
    (e) => {
      const programName =
        e.target.parentElement.parentElement.children[0].textContent;

      if (objectForEdit[programName]) {
        setEditAcp(true);
        setSelectedProgram(objectForEdit[programName]);
        setShowEdit(true);
      }
    },
    [objectForEdit, setEditAcp] // depends only on objectForEdit
  );

  // -------------------- API CALL --------------------
  useEffect(() => {
    const fetchPrograms = async () => {
      try {
        const res = await api.get(
          `/api/web/acpPrograms/all?serviceProvider=${parseLoginRes?.company}`
        );

        const programs = res.data.data ?? [];

        // Extract codes
        const codes = programs
          .filter((program) => program.code !== undefined)
          .map((program) => program.code);
        setArrayOfCodes(codes);

        // Map program objects for edit
        const editMap = {};
        programs.forEach((element) => {
          editMap[element.name] = element;
          element.edit = (
            <span
              className="pi pi-user-edit"
              style={{ cursor: "pointer" }}
              onClick={editAcpProgram}
            />
          );
        });
        setObjectForEdit(editMap);

        // Only set list view if not in edit mode
        if (!showEdit) {
          setShowAcps(programs);
        }
      } catch (err) {
        // TODO: toast or logger
      }
    };

    fetchPrograms();
  }, [parseLoginRes.company, showEdit, editAcpProgram]); // ✅ proper deps// re-run if company or edit mode changes

  // -------------------- UI --------------------
  return (
    <div>
      {/* ---------- Show Table or Loader ---------- */}
      {!showEdit ? (
        <div style={{ marginTop: "7.5rem" }}>
          {showAcps ? (
            <DataTable
              tableStyle={{ minWidth: "50rem" }}
              value={showAcps}
              showGridlines
            >
              <Column field="name" header="Name" />
              <Column field="description" header="Description" />
              <Column body={renderBanner} header="Banner" />
              <Column field="code" header="Code" />
              <Column body={renderActiveStatus} header="Status" />
              <Column
                field="edit"
                style={{ textAlign: "center" }}
                header="Edit"
              />
            </DataTable>
          ) : (
            <ProgressSpinner className="flex justify-content-center" />
          )}
        </div>
      ) : (
        // ---------- Edit Program View ----------
        <UpdateProgram
          setShowAcps={setShowAcps}
          arrayofcodes={arrayOfCodes}
          setShowEdit={setShowEdit}
          selectedProgram={selectedProgram}
          setEditAcp={setEditAcp}
        />
      )}
    </div>
  );
};

export default ShowPrograms;
